export class StringExtensions {
  public static EmptyGuid: string = '00000000-0000-0000-0000-000000000000';
  public static StringIsNotEmpty(str: string) {
    return typeof str != 'undefined' && str != null && str.length > 0;
  }
  public static StringIsEmpty(str: string) {
    return typeof str === 'undefined' || str === null || str.length === 0;
  }
}
